module.exports = {
      id: "automobile-usage",
      viewBox: "0 0 31.664 23.083",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#automobile",
      toString: function () {
        return this.url;
      }
    }